export const navigationData = [
  {
    title: "Rise of Blogging",
    id: "rise_of_blogging",
    years: "986 - 2000"
  },
  {
    title: "WordPressism",
    id: "wordpressism",
    years: "1998 - 2004"
  },
  {
    title: "Myspacism",
    id: "myspacism",
    years: "2003 - 2006"
  },
  {
    title: "Facebook Art",
    id: "facebook_art",
    years: "2004 - present"
  },
  {
    title: "Youtubism",
    id: "youtubism",
    years: "2005 - present"
  },
  {
    title: "Twitt Art",
    id: "twitt_art",
    years: "2006 - present"
  },
  {
    title: "Instagraminism",
    id: "instagraminism",
    years: "2010 - present"
  },
  {
    title: "Twitch Art",
    id: "twitch_art",
    years: "2011 - present"
  },
  {
    title: "Tiktokko",
    id: "tiktokko",
    years: "2016 - present"
  }
]; 